<template>
  <div class="search-input" v-if="showInput">
    <el-popover
      width="300"
      trigger="focus"
      :tabindex="200"
      placement="bottom"
      :visible-arrow="false"
      @hide="poperHide"
      popper-class="custom-search-input-popper"
    >
      <!-- v-model="visible" -->
      <el-input
        slot="reference"
        v-model="input"
        :size="$elsize"
        @input="inputEvent"
        placeholder="请输入内容"
        prefix-icon="el-icon-search"
      />
      <div class="custom-search-input-popper-content">
        <div class="history-hot wh100" v-if="!input">
          <div
            class="history"
            v-if="$store.getters.isLogin && historyList.length"
          >
            <div class="sub-title">
              <span>历史</span>
              <span
                class="el-icon-delete delete-icon"
                @click="clearHistory"
              ></span>
            </div>
            <div class="history-list">
              <!-- :disable-transitions="true" -->
              <el-tag
                size="mini"
                type="info"
                class="history-item"
                @close="del(history)"
                :key="history.id"
                v-for="history in historyList"
                closable
                ><span>{{ maxText(history.search_word) }}</span>
              </el-tag>
            </div>
          </div>
          <div class="hot">
            <div class="sub-title">
              <span>热搜</span>
            </div>
            <div class="hot-list">
              <div
                class="hot-item"
                v-for="(hot, idx) in hotList"
                :key="hot.id"
                @click="hotTap(hot)"
              >
                <div class="hot-item-number">
                  <img class="wh100" :src="hotRankPath(idx)" alt="" />
                </div>
                <div class="hot-item-title pointer hover-primary">
                  {{ hot.search_word }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="suggest-list wh100" v-else>
          <div class="loading" v-if="dataLoading">
            <span class="el-icon-loading"></span>
          </div>
          <template v-else>
            <div
              class="suggest"
              v-for="suggest in dataList"
              :key="suggest.id"
              @click="suggestTap(suggest)"
            >
              <div class="suggest-title ellipsis">
                {{ suggest.name }}
              </div>
              <div class="suggest-tag">
                {{ suggest.type }}
              </div>
            </div>
            <div class="suggest-empty" v-if="!dataList.length">
              <span class="empty-tips">未搜索到相关内容</span>
            </div>
            <div class="more-search-result">
              <span @click.stop="navigateToSearch">点击查看更多搜索内容</span>
            </div>
          </template>
        </div>
      </div>
    </el-popover>
  </div>
</template>
<script>
// mapGetters
import { mapActions, mapMutations } from "vuex";
import { hadStorage } from "@/utils/storage";
export default {
  name: "search-input",
  data: function () {
    return {
      input: "",
      visible: false,
      updateSearch: false, // 是否已经搜索
      dataPage: 1,
      dataSize: 10,
      dataTotal: 0,
      dataLoading: false,
      condList: [], // 查询条件
      dataList: [],
    };
  },
  computed: {
    // ...mapGetters(["searchHistory", "hotSearch"]),
    historyList() {
      return this.$store.getters.searchHistory.slice(0, 5);
    },
    hotList() {
      return this.$store.getters.hotSearch.slice(0, 5);
    },
    showInput() {
      return this.$route.path !== "/search";
    },
  },
  methods: {
    ...mapMutations("user", ["SET_SEARCH_HISTORY"]),
    ...mapActions("user", ["fetchSearchHistory"]),
    ...mapActions("public", ["fetchHotSearch"]),
    hotRankPath(idx) {
      return require(`@/assets/img/hot-rank-${idx + 1}.png`);
    },

    navigateToSearch() {
      this.$router.push({
        name: "search",
        params: { text: this.input },
      });
      this.input = "";
    },
    poperHide() {
      if (!this.updateSearch) return;
      const { isLogin } = this.$store.getters;
      isLogin && this.fetchSearchHistory();
      this.fetchHotSearch();
    },
    inputEvent(input) {
      this.$tools.debounce(() => {
        input.trim() && this.loadList(input);
      }, 500);
    },
    /*  单独删除某条历史路 */
    async delHistory(history) {
      try {
        const { id: search_id } = history;
        const resp = await this.$fetch({
          url: "/Index/delUserSearch",
          method: "GET",
          params: { search_id },
          unShowErrorTip: true,
        });
        const { state } = resp;
        if (state !== 0) return;
        this.updateSearch = true;
      } catch (error) {
        /* eslint-disable-next-line no-empty */
      }
    },
    /* 清除历史记录  */
    async clearHistory() {
      try {
        const resp = await this.$fetch({
          url: "/Index/delAllUserSearch",
          method: "GET",
          params: { type: "PC" },
          unShowErrorTip: true,
        });
        const { state } = resp;
        if (state !== 0) return;
        this.SET_SEARCH_HISTORY([]);
        this.updateSearch = true;
      } catch (error) {
        /* eslint-disable-next-line no-empty */
      }
    },
    del(history) {
      const { searchHistory } = this.$store.getters;
      const list = searchHistory.filter((it) => it.id !== history.id);
      this.SET_SEARCH_HISTORY(list);
      this.delHistory(history);
      // console.log("history >>::", history);
    },
    maxText(text) {
      if (typeof text !== "string") return "";
      let result = text.trim();
      if (result.length > 18) result = result.substring(0, 18) + "...";
      return result;
    },
    hotTap(hot) {
      const { search_word } = hot;
      const input = search_word.trim();
      this.input = input;
      this.loadList(input);
    },
    suggestTap(suggest) {
      const { id, type, dynamic_type } = suggest;
      const dynamicMap = new Map([
        ["文章", "paper"],
        ["专利", "patent"],
        ["活动", "activity"],
        ["招募", "recruit"],
      ]);
      const pathMap = new Map([
        ["动态", `/dynamic-detail/${dynamicMap.get(dynamic_type)}/${id}`],
        ["推广", `/activity/detail/${id}`],
        ["用户", `/user-detail/${id}`],
        ["社群", `/community/detail/${id}`],
        ["问答", `/question/detail/${id}`],
      ]);
      const path = pathMap.get(type);
      path && this.$router.push(path);
    },
    async loadList(input, more) {
      try {
        const params = {
          page_num: this.dataPage,
          page_size: this.dataSize,
          search: input,
        };
        this.dataLoading = true;
        const resp = await this.$fetch({
          url: "/Index/getSimpleSearchResult",
          method: "POST",
          data: params,
        });
        this.dataLoading = false;
        const { state, data } = resp || {};
        if (state !== 0) return;
        const { row_list = [], rows_count } = data || {};
        this.dataList = more ? this.dataList.concat(row_list) : row_list;
        this.dataTotal = rows_count || 0;
        // this.dataPage++;
        this.updateSearch = true;
      } catch (error) {
        this.dataLoading = false;
        console.log("error >>::", error);
        /* eslint-disable-next-line no-empty */
      }
    },
    createInit() {
      const { isLogin } = this.$store.getters;
      const hasSearchHistory = hadStorage({ key: "user_search_history" });
      const hasHotSearch = hadStorage({ key: "public_hot_search" });
      if (!hasHotSearch) this.fetchHotSearch();
      if (!hasSearchHistory && isLogin) this.fetchSearchHistory();
    },
  },
  created() {
    this.createInit();
  },
};
</script>
<style lang="scss">
.custom-search-input-popper {
  top: 34px !important;
  // z-index: 10087 !important;
}
</style>
<style lang="scss" scoped>
.search-input {
  width: 300px;
  ::v-deep .el-input__inner {
    border-radius: 32px;
    background-color: #f5f5f5;
  }
}
.custom-search-input-popper-content {
  padding: 0 1em;
  font-size: 14px;
  .sub-title {
    color: #909399;
    padding-top: 0.6em;
    padding-bottom: 0.8em;
    .delete-icon {
      cursor: pointer;
      margin-left: 0.5em;
      &:hover {
        color: var(--color-primary);
      }
    }
  }
  .history-list {
    display: flex;
    gap: 0.5em 1em;
    flex-wrap: wrap;
    color: #606266;
    margin-bottom: 1em;
    .history-item {
      // display: inline-block;
      // // max-width: 100px;
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // word-break: break-all;
      // hyphens: auto;
    }
  }
  .hot {
    .hot-list {
      .hot-item {
        gap: 8px;
        display: flex;
        color: #606266;
        margin-bottom: 20px;
        .hot-item-number {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
}
.suggest-list {
  max-height: 400px;
  overflow-y: auto;
  .suggest {
    display: flex;
    gap: 8px;
    font-size: 14px;
    margin-bottom: 8px;
    cursor: pointer;
    .suggest-title {
      flex: 1;
      &:hover {
        color: var(--color-primary);
      }
    }
    .suggest-tag {
      font-size: 12px;
      color: var(--color-primary);
    }
  }
}
.suggest-empty {
  // padding: 10px;
  text-align: center;
  .empty-tips {
    font-size: 12px;
    padding: 5px 2px;
    color: var(--color-info-light);
  }
}
.loading {
  text-align: center;
}
.more-search-result {
  color: var(--color-primary);
  cursor: pointer;
  padding: 5px 2px;
  text-align: center;
  &:hover {
    // background-color: var(--color-primary-light);
  }
}
</style>
